import clsx from "clsx";
import { useEffect, useState, useRef } from "react";
import OpeningAudio from "@/assets/music/melati-suci.mp3"
import LoadingEngrave100 from "@/assets/imgs/loading-engrave-100w.webp"
import LoadingEngrave200 from "@/assets/imgs/loading-engrave-200w.webp"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeHigh, faVolumeXmark } from "@fortawesome/free-solid-svg-icons";
import GeneralLayout from "@/layouts/General";
import ProcessModal from "@/components/ProcessModal";
import MonkeyAnimationComponent from "./MonkeyAnimation";
import { useGlobalContext } from "@/global/GlobalContext";
import Loader from "../../components/Loader";

const Home = () => {
  const { loading, setLoading, isPlaying, setIsPlaying } = useGlobalContext()
  const [canClick, setCanClick] = useState(false)
  // const [showPopup, setShowPopup] = useState(false)
  // const [modalContent, setModalContent] = useState(null)
  let progress = 0;
  const mediaLg = window.matchMedia("(min-width: 1024px)")
  const openingAudio = useRef(null)
  // const popupTimerRef = useRef(null)

  useEffect(() => {
    const progressBarFill = document.querySelector(".progress-bar-fill");
    const clickText = document.getElementById("clickText")
    const updateProgressBar = () => {
      progress += 1;
      progressBarFill.style.width = `${progress}%`;
      if (progress < 100) {
        setTimeout(updateProgressBar, 2);
      }
    };

    updateProgressBar();

    const timer = setTimeout(() => {
      clickText.classList.toggle("exit")
      clickText.classList.toggle("initial")
      if (mediaLg.matches) document.getElementById("bg").classList.add("cursor-pointer")
      setCanClick(true)
    }, 3000)

    // TODO: cek amankah?
    return () => clearTimeout(timer)
  }, [])

  const removeBG = () => {
    if (canClick) {
      setLoading("exit")
      if (openingAudio.current) {
        openingAudio.current.play().then(() => {
          setIsPlaying(true);
        }).catch(error => {
          console.error("Audio playback failed:", error);
        });
      }
      /*
      // schedule the temporary closure popup 3s after the initial click
      console.debug("Home: removeBG called — scheduling popup in 3s")
      if (popupTimerRef.current) clearTimeout(popupTimerRef.current)
      popupTimerRef.current = setTimeout(() => {
        console.debug("Home: showing popup from removeBG now")
        const content = {
          title: "Temporary Closure Notice",
          msg: "We will be closed at 3:00 PM on Saturday, September 5, 2026.\nWe will reopen on Sunday, September 6, 2026 at 10:00 AM.",
          isOpen: true
        }
        setModalContent(content)
        setShowPopup(true)
        popupTimerRef.current = null
      }, 3000)
      */
    }
  }

  const muteAudio = () => {
    if (isPlaying) {
      openingAudio.current.pause()
    } else {
      openingAudio.current.play()
    }
    setIsPlaying(!isPlaying)
  }

  /*
  useEffect(() => {
    return () => {
      if (popupTimerRef.current) {
        clearTimeout(popupTimerRef.current)
        popupTimerRef.current = null
      }
    }
  }, [])

  const handlePopupTrigger = (e) => {
    e.stopPropagation()
    if (popupTimerRef.current) clearTimeout(popupTimerRef.current)
    popupTimerRef.current = setTimeout(() => {
      setModalContent({
        title: "Temporary Closure Notice",
        msg: "We will be closed at 3:00 PM on Saturday, September 5, 2026.\nWe will reopen on Sunday, September 6, 2026 at 10:00 AM.",
        isOpen: true
      })
      setShowPopup(true)
      popupTimerRef.current = null
    }, 3000)
  }

  const handleHeroClick = (e) => {
    // Called when user clicks the hero/image section on the main page
    console.debug("Home: hero clicked, scheduling popup in 3s")
    if (popupTimerRef.current) clearTimeout(popupTimerRef.current)
    popupTimerRef.current = setTimeout(() => {
      console.debug("Home: showing popup now")
      setModalContent({
        title: "Temporary Closure Notice",
        msg: "We will be closed at 3:00 PM on Saturday, September 5, 2026.\nWe will reopen on Sunday, September 6, 2026 at 10:00 AM.",
        isOpen: true
      })
      setShowPopup(true)
      popupTimerRef.current = null
    }, 3000)
  }
  */

  return (
    <>
      {/* opening section */}
      <div id="bg" onClick={() => removeBG()} className={clsx("fixed z-50 bg-[#6c5f58] h-screen w-full flex justify-center items-center", loading)}>
        {/* <div className="">
          <img src={OptionLogo} width="100" height="100" className="w-1/5 mx-auto" />
          <div className="progress-bar mx-auto mt-4">
            <div className="progress-bar-fill"></div>
          </div>
        </div> */}
        {/* TODO: coba cek, apakah useEffect di atas (yg ngambil query berdasarkan class progress-bar-fill jalan) */}
        <Loader>
          <div className="progress-bar mx-auto mt-4">
            <div className="progress-bar-fill"></div>
          </div>
        </Loader>
        {/* Click trigger centered on the opening image/logo area. Clicking here schedules popup after 3s
        <div
          id="popupTrigger"
          onClick={(e) => handlePopupTrigger(e)}
          className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-40 h-40 cursor-pointer"
          aria-label="Show temporary closure notice in 3 seconds"
        >
          <span className="sr-only">Trigger temporary closure notice (appears in 3 seconds)</span>
        </div>
        */}

        <div id="clickText" className="absolute bottom-[100px] lg:bottom-8 exit justify-center">
          <div className="text-center">
            <span className="font-headlines text-[#b99a59] text-base leading-4">Click Anywhere</span>
            <img
              src={LoadingEngrave100}
              srcSet={`${LoadingEngrave100} 100w, ${LoadingEngrave200} 200w`}
              sizes="100px"
              width="100"
              height="18"
              loading="eager"
              decoding="async"
              alt="Loading ornament"
            />
          </div>
        </div>
      </div>
      <GeneralLayout bgColor="bg-white">
        {/* <MonkeyAnimationComponent loadingStatus={loading} onHeroClick={handleHeroClick} /> */}
        <MonkeyAnimationComponent loadingStatus={loading} />
      </GeneralLayout>
      <div className="fixed z-20 bg-white bottom-6 lg:bottom-8 right-6 p-2 rounded-full">
        <button onClick={muteAudio} aria-label={isPlaying ? "Mute audio" : "Unmute audio"}>
          <FontAwesomeIcon icon={!isPlaying ? faVolumeXmark : faVolumeHigh} size="lg" style={{ color: "#b99a59" }} />
        </button>
      </div>
      <audio ref={openingAudio} src={OpeningAudio}></audio>
      {/* <ProcessModal pModalContent={modalContent} /> */}
    </>
  )
}

export default Home
